import { APIModel } from '@shared/interfaces';
import { PollingStatus } from '@/tax/models';
import { StatusProvider } from '@/tax/models';

export class PersonalTaxSync implements APIModel {
    id = -1;
    status = PollingStatus.Init;
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;
    creationDate = new Date();
    minimal = true;

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.minimal = data.minimal ?? true;
        this.status = data.status ?? PollingStatus.Init;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;
        this.creationDate = data.creation_date != null ? new Date(data.creation_date) : this.creationDate;
        return this;
    }

    serialize(): any {
        return {
            id: this.id,
            minimal: this.minimal,
            status: this.status,
            status_message: this.statusMessage,
            status_message_provider: this.statusMessageProvider,
            creation_date: this.creationDate.toISOString(),
        };
    }
}
